import React from "react";
import { cn } from "@/lib/utils";

const SIZE_CLASSES = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

// Shared brand mark keeps the supplied logo consistent in navigation, auth, and dashboards.
export default function BrandLogo({
  className,
  compact = false,
  inverse = false,
  size = "md",
  subtitle = "The real place for real estate",
}) {
  return (
    <span className={cn("brand-logo inline-flex min-w-0 items-center gap-2.5", className)}>
      <span className={cn("brand-logo-shell shrink-0", SIZE_CLASSES[size] || SIZE_CLASSES.md)}>
        <img
          src="/brand/real-place-mark.svg"
          alt="ShreeHomes"
          aria-hidden="true"
          className="brand-logo-mark h-full w-full object-contain"
        />
      </span>
      {!compact && (
        <span className="flex min-w-0 flex-col leading-none">
          <span
            className={cn(
              "brand-logo-name truncate font-display text-[15px] font-black tracking-[-0.035em] sm:text-base",
              inverse ? "text-white" : "text-slate-950"
            )}
          >
            ShreeHomes
          </span>
          <span
            className={cn(
              "mt-1 truncate text-[8px] font-extrabold uppercase tracking-[0.16em]",
              inverse ? "text-white/55" : "text-slate-500"
            )}
          >
            {subtitle}
          </span>
        </span>
      )}
    </span>
  );
}
